var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"secondary","dark":""},on:{"click":function($event){return _vm.exportPresences(_vm.eventId)}}},[_vm._v("Exporter les présences")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }